export const FETCH_NOTIFICATION = "/notifications/";

// send a referral email
export const SEND_REFERRAL_EMAIL = "/referral/:id/send/";
